import AuthenticationRepository from './AuthenticationRepository'

import TopicRepository from './TopicRepository'
import TopicAccountRepository from './TopicAccountRepository'

import SeasonRepository from './SeasonRepository'

import SeasonEntryRepository from './SeasonEntryRepository'
import SeasonEntryRosterRepository from './SeasonEntryRosterRepository'

import SeasonGroupRepository from './SeasonGroupRepository'
import SeasonGroupingRepository from './SeasonGroupingRepository'

import SeasonGameRepository from './SeasonGameRepository'
import SeasonGameEventRepository from './SeasonGameEventRepository'

import TeamRepository from './TeamRepository'
import TeamAccountRepository from './TeamAccountRepository'

import PlayerRepository from './PlayerRepository'

import FieldRepository from './FieldRepository'
import FieldGroupRepository from './FieldGroupRepository'

import CategoryRepository from './CategoryRepository'

interface repositoryObject {
  [name: string]: any
}

const repositories: repositoryObject = {
  authentication: AuthenticationRepository,

  topic: TopicRepository,
  topicAccount: TopicAccountRepository,

  season: SeasonRepository,

  seasonEntry: SeasonEntryRepository,
  seasonEntryRoster: SeasonEntryRosterRepository,

  seasonGroup: SeasonGroupRepository,
  seasonGrouping: SeasonGroupingRepository,

  seasonGame: SeasonGameRepository,
  seasonGameEvent: SeasonGameEventRepository,

  team: TeamRepository,
  teamAccount: TeamAccountRepository,

  player: PlayerRepository,

  field: FieldRepository,
  fieldGroup: FieldGroupRepository,

  category: CategoryRepository
}

export const RepositoryFactory = {
  get: (name: string) => repositories[name]
}